export enum CouponFinality {
  ORDER = 'ORDER',
  SUBSCRIPTION = 'SUBSCRIPTION',
  VOUCHER = 'VOUCHER',
}



// WEBPACK FOOTER //
// ./src/app/pages/coupons/enums/coupon-finality.enum.ts